import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SimpleImageLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'loading', // loading, loaded, error
      imageSrc: null,
    };
    this.imageLoader = null;
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.setState({ status: 'loading', imageSrc: null });
      this.loadImage();
    }
  }

  componentWillUnmount() {
    if (this.imageLoader) {
      this.imageLoader.onload = null;
      this.imageLoader.onerror = null;
      this.imageLoader = null;
    }
  }

  loadImage() {
    const { src, fallbackSrc } = this.props;

    if (!src) {
      if (fallbackSrc) {
        this.setState({ status: 'loaded', imageSrc: fallbackSrc });
      } else {
        this.setState({ status: 'error' });
      }
      return;
    }

    // Create new image loader
    this.imageLoader = new Image();

    this.imageLoader.onload = () => {
      this.setState({ status: 'loaded', imageSrc: src });
      if (this.props.onLoad) {
        this.props.onLoad();
      }
    };

    this.imageLoader.onerror = () => {
      if (fallbackSrc && fallbackSrc !== src) {
        // Try fallback
        const fallbackLoader = new Image();
        fallbackLoader.onload = () => {
          this.setState({ status: 'loaded', imageSrc: fallbackSrc });
        };
        fallbackLoader.onerror = () => {
          this.setState({ status: 'error' });
          if (this.props.onError) {
            this.props.onError();
          }
        };
        fallbackLoader.src = fallbackSrc;
      } else {
        this.setState({ status: 'error' });
        if (this.props.onError) {
          this.props.onError();
        }
      }
    };

    // Start loading
    this.imageLoader.src = src;
  }

  render() {
    const {
      alt,
      className,
      style,
      placeholderColor = '#f8f9fa',
      showError = true,
      errorMessage = 'Resim Yüklenemedi',
      imgStyle = {},
    } = this.props;

    const { status, imageSrc } = this.state;

    const containerStyle = {
      position: 'relative',
      width: '100%',
      height: '100%',
      backgroundColor: placeholderColor,
      overflow: 'hidden',
      ...style,
    };

    const imageStyle = {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'center center',
      transition: 'opacity 0.3s ease',
      opacity: status === 'loaded' ? 1 : 0,
      ...imgStyle,
    };

    const loadingStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '1000px 100%',
      animation: 'shimmer 2s infinite',
      display: status === 'loading' ? 'block' : 'none',
    };

    const errorStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      color: '#9ca3af',
      fontSize: '12px',
      display: status === 'error' && showError ? 'block' : 'none',
    };

    return (
      <div className={className} style={containerStyle}>
        {/* Loading shimmer */}
        <div style={loadingStyle} />

        {/* Error state */}
        {status === 'error' && showError && (
          <div style={errorStyle}>
            <div style={{ fontSize: '24px', marginBottom: '8px' }}>📷</div>
            <div>{errorMessage}</div>
          </div>
        )}

        {/* Image */}
        {imageSrc && (
          <img
            src={imageSrc}
            alt={alt}
            style={imageStyle}
            loading="lazy"
            decoding="async"
          />
        )}
      </div>
    );
  }
}

SimpleImageLoader.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  fallbackSrc: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  imgStyle: PropTypes.object,
  placeholderColor: PropTypes.string,
  showError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
};

export default SimpleImageLoader;


// WEBPACK FOOTER //
// ./src/components/shared/SimpleImageLoader.js